import { __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__ } from '@atlassian/relay-environment-provider/environment';
import RelayModernEnvironment from 'relay-runtime/lib/store/RelayModernEnvironment';

import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import ProjectPageAggQuery, {
	type ProjectPageAggQuery as ProjectPageAggQueryType,
} from '../components/ProjectPageAgg/__generated__/ProjectPageAggQuery.graphql';

export const projectPageAggResource = createRelayResource<ProjectPageAggQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const containerId = (resourceContext as ResourceContext).collabContext?.contextId ?? '';
		const key = routerContext.match.params.id ?? '';
		const isCombinedAggQueryEnabled = fg('townsquare_enable_combined_agg_query_sidebar');
		const isEditPermsEnabled = fg('townsquare_edit_permissions_projects');

		return {
			query: ProjectPageAggQuery,
			environment: __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__ as RelayModernEnvironment,
			variables: {
				searchQuery: `key = ${key}`,
				containerId,
				isCombinedAggQueryEnabled,
				isEditPermsEnabled,
			},
		};
	},
});
